"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsList = void 0;
var Utilities_1 = require("../../Utilities");
var DetailsList_base_1 = require("./DetailsList.base");
var DetailsList_styles_1 = require("./DetailsList.styles");
exports.DetailsList = Utilities_1.styled(DetailsList_base_1.DetailsListBase, DetailsList_styles_1.getStyles, undefined, {
    scope: 'DetailsList',
});
//# sourceMappingURL=DetailsList.js.map